<template>
  <div class="index" v-cloak>
    <div
      class="follow acea-row row-between-wrapper"
      v-if="followHid && isWeixin && isLogin"
    >
      <div>点击“立即关注”即可关注公众号</div>
      <div class="acea-row row-middle">
        <div class="bnt" @click="followTap">立即关注</div>
        <span class="iconfont icon-guanbi" @click="closeFollow"></span>
      </div>
    </div>
    <div class="followCode" v-if="followCode">
      <div class="pictrue"><img :src="followUrl" /></div>
      <div class="mask" @click="closeFollowCode"></div>
    </div>
    <div class="header acea-row row-center-wrapper">
      <router-link :to="'/search'" class="search acea-row row-middle">
        <span class="iconfont icon-xiazai5"></span>搜索商品
      </router-link>
    </div>
    <div class="slider-banner banner">
      <swiper :options="swiperOption" v-if="banner.length > 0">
        <swiper-slide v-for="(item, index) in banner" :key="index"  >
          <img :src="item.pic"/>
        </swiper-slide>
        <div class="swiper-pagination paginationBanner" slot="pagination"></div>
      </swiper>
    </div>

    <div class="nav acea-row " style="padding-top: 0.3rem">
      <router-link
        :to="item.wap_url ? item.wap_url : ''"
        class="item"
        v-for="(item, index) in menus"
        :key="index"

      >
        <div class="pictrue"><img :src="item.pic"   /></div>
        <div>{{ item.name }}</div>
      </router-link>
    </div>
    <div class="news acea-row row-between-wrapper">

      <div class="swiper-no-swiping new-banner">
        <swiper
          class="swiper-wrapper"
          :options="swiperRoll"
          v-if="roll.length > 0"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in roll"
            :key="index"
          >
            <router-link
              :to="item.wap_url ? item.wap_url : ''"
              class="acea-row row-between-wrapper"
            >
              <div class="text acea-row row-between-wrapper">
                <div class="label" v-if="item.show === '是'">最新</div>
                <div class="newsTitle line1">{{ item.info }}</div>
              </div>
              <div class="iconfont icon-xiangyou"></div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>


    <div class="wrapper" v-if="info.good_list.length > 0">
      <div class="newProducts xiaosan">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
                  class="swiper-slide"
                  v-for="(item, index) in info.good_list"
                  :key="index"
          >
            <div @click="goDetail(item)">
              <div class="img-box">
                <img v-lazy="item.image" />
                <span
                        class="pictrue_log_medium pictrue_log_class"
                        v-if="item.activity && item.activity.type === '1'"
                >秒杀</span
                >
                <span
                        class="pictrue_log_medium pictrue_log_class"
                        v-if="item.activity && item.activity.type === '2'"
                >砍价</span
                >
                <span
                        class="pictrue_log_medium pictrue_log_class"
                        v-if="item.activity && item.activity.type === '3'"
                >拼团</span
                >
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money font-color-red">
                <span class="vip-money" v-if="!item.vip_price || item.vip_price == 0">
                ￥{{ item.price }}<span v-if="item.point>0">+{{item.point}}购物券</span>
                </span>
                <span class="vip-money" style="font-size:0.2rem;" v-if="item.vip_price && item.vip_price > 0">
                  ￥{{ item.vip_price }}<span v-if="item.vip_point>0">+{{item.vip_point}}购物券</span>
                </span>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>



    <div
      class="specialArea acea-row row-between-wrapper"
      v-if="activity.length>0"
    >
      <div class="list acea-row">
        <router-link
          :to="item.wap_link ? item.wap_link : ''"
          class="item"
          v-for="(item, index) in activity"
          :key="index"
        >
          <img v-lazy="item.pic" />
        </router-link>
      </div>
    </div>



    <div class="wrapper" v-if="info.fastList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">快速选择</div>
          <div class="line1">{{ info.fastInfo }}</div>
        </div>
        <router-link :to="'/category'" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div class="scroll-product">
        <swiper class="swiper-wrapper" :options="swiperScroll">
          <swiper-slide
            v-for="(item, index) in info.fastList"
            :key="index"
            class="swiper-slide"
          >
            <router-link
              :to="{
                path: '/goods_list',
                query: { id: item.id, title: item.cate_name }
              }"
            >
              <div class="img-box">
                <img v-lazy="item.pic" />
              </div>
              <div class="pro-info line1">{{ item.cate_name }}</div>
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>


    <div class="wrapper" v-for="(items, indexs) in indexarea" :key="indexs">

      <router-link v-if="items.index_img" :to="{ path: '/area_goods/' + items.id }" class="adver">
        <img v-lazy="items.index_img" />
      </router-link>

      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
                  class="swiper-slide"
                  v-for="(item, index) in items.index_goods"
                  :key="index"
          >
            <div @click="goDetail(item)">
              <div class="img-box">
                <img v-lazy="item.image" />
                <span
                        class="pictrue_log_medium pictrue_log_class"
                        v-if="item.activity && item.activity.type === '1'"
                >秒杀</span>
                <span
                        class="pictrue_log_medium pictrue_log_class"
                        v-if="item.activity && item.activity.type === '2'"
                >砍价</span>
                <span
                        class="pictrue_log_medium pictrue_log_class"
                        v-if="item.activity && item.activity.type === '3'"
                >拼团</span>
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money font-color-red">
                <span class="vip-money" v-if="!item.vip_price || item.vip_price == 0">
                ￥{{ item.price }}<span v-if="item.point>0">+{{item.point}}购物券</span>
                </span>
                <span class="vip-money" style="font-size:0.2rem;" v-if="item.vip_price && item.vip_price > 0">
                  ￥{{ item.vip_price }}<span v-if="item.vip_point>0">+{{item.vip_point}}购物券</span>
                </span>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>


    <div
      class="wrapper"
      v-if="info.bastList.length > 0"
    >
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">精品推荐</div>
          <div class="line1">{{ info.bastInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 1 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
      <div v-if="info.routine_home_index_best_banner.length==1" style="width: 6.9rem;

    margin: 0.28rem auto 0 auto;height:auto;">
        <div class="adver" style="height:auto;">

          <router-link :to="info.routine_home_index_best_banner[0].wap_link ? info.routine_home_index_best_banner[0].wap_link : ''"
          ><img v-lazy="info.routine_home_index_best_banner[0].img" style="height:auto;"
          /></router-link>
        </div>
      </div>
      <div class="slider-banner boutique" v-if="info.routine_home_index_best_banner.length!=1">
        <swiper class="swiper-wrapper" :options="swiperBoutique1">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.routine_home_index_best_banner"
            :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
              ><img v-lazy="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique"></div>
      </div>
      <Good-list :good-list="info.bastList" :is-sort="false"></Good-list>
    </div>
    <div class="hotList" v-if="likeInfo.length > 0">
      <div class="hot-bg">
        <div class="title acea-row row-between-wrapper">
          <div class="text line1">
            <span class="label">热门榜单</span>根据销量、搜索、好评等综合得出
          </div>
          <router-link :to="{ path: '/hot_new_goods/' + 2 }" class="more">
            更多<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
      </div>
      <div class="list acea-row row-middle">
        <div @click="goDetail(item)"

          class="item"
          v-for="(item, index) in likeInfo"
          :key="index"
        >
          <div class="pictrue">
            <img :src="item.image" />
            <img src="@assets/images/one.png" class="numPic" v-if="index === 0" />
            <img src="@assets/images/two.png" class="numPic" v-else-if="index === 1"  />
            <img src="@assets/images/three.png" class="numPic" v-else-if="index === 2" />

            <span class="pictrue_log_medium pictrue_log_class" v-if="item.activity && item.activity.type === '1'" style="left:auto;right:0">秒杀</span>
            <span class="pictrue_log_medium pictrue_log_class" v-if="item.activity && item.activity.type === '2'" style="left:auto;right:0">砍价</span>
            <span class="pictrue_log_medium pictrue_log_class" v-if="item.activity && item.activity.type === '3'" style="left:auto;right:0">拼团</span>

          </div>
          <div class="name line1">{{ item.store_name }}</div>
          <div class="money font-color-red">
            <span class="num" style="font-size:0.2rem;" v-if="!item.vip_price || item.vip_price == 0">￥{{ item.price }}<span v-if="item.point>0">+{{item.point}}购物券</span></span>

            <span class="num" style="font-size:0.2rem;" v-if="item.vip_price && item.vip_price > 0">
                  ￥{{ item.vip_price }}<span v-if="item.vip_point>0">+{{item.vip_point}}购物券</span>
            </span>

          </div>
        </div>
      </div>
    </div>






    <div class="wrapper" v-if="info.firstList.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">
            首发新品<span class="new font-color-red">NEW~</span>
          </div>
          <div class="line1">{{ info.firstInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 3 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>

      <div v-if="info.routine_home_index_new_banner.length==1" style="width: 6.9rem;

    margin: 0.28rem auto 0 auto;height:auto;">
        <div class="adver" style="height:auto;">

          <router-link :to="info.routine_home_index_new_banner[0].wap_link ? info.routine_home_index_new_banner[0].wap_link : ''"
          ><img v-lazy="info.routine_home_index_new_banner[0].img" style="height:auto;"
          /></router-link>
        </div>
      </div>
      <div class="slider-banner boutique" v-if="info.routine_home_index_new_banner.length!=1">
        <swiper class="swiper-wrapper" :options="swiperBoutique">
          <swiper-slide
              class="swiper-slide"
              v-for="(item, index) in info.routine_home_index_new_banner"
              :key="index"
          >
            <router-link :to="item.wap_link ? item.wap_link : ''"
            ><img v-lazy="item.img"
            /></router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-pagination paginationBoutique1"></div>
      </div>

      <div class="newProducts">
        <swiper class="swiper-wrapper" :options="swiperProducts">
          <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.firstList"
            :key="index"
          >
            <div @click="goDetail(item)">
              <div class="img-box">
                <img v-lazy="item.image" />
                <span
                  class="pictrue_log_medium pictrue_log_class"
                  v-if="item.activity && item.activity.type === '1'"
                  >秒杀</span
                >
                <span
                  class="pictrue_log_medium pictrue_log_class"
                  v-if="item.activity && item.activity.type === '2'"
                  >砍价</span
                >
                <span
                  class="pictrue_log_medium pictrue_log_class"
                  v-if="item.activity && item.activity.type === '3'"
                  >拼团</span
                >
              </div>
              <div class="pro-info line1">{{ item.store_name }}</div>
              <div class="money font-color-red">
                <span class="vip-money" v-if="!item.vip_price || item.vip_price == 0">
                ￥{{ item.price }}<span v-if="item.point>0">+{{item.point}}购物券</span>
                </span>
                <span class="vip-money" style="font-size:0.2rem;" v-if="item.vip_price && item.vip_price > 0">
                  ￥{{ item.vip_price }}<span v-if="item.vip_point>0">+{{item.vip_point}}购物券</span>
                </span>
              </div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>




    <div class="wrapper" v-if="benefit.length > 0">
      <div class="title acea-row row-between-wrapper">
        <div class="text">
          <div class="name line1">促销单品</div>
          <div class="line1">{{ info.salesInfo }}</div>
        </div>
        <router-link :to="{ path: '/hot_new_goods/' + 4 }" class="more"
          >更多<span class="iconfont icon-jiantou"></span
        ></router-link>
      </div>
    </div>

    <div v-if="info.routine_home_index_benefit_banner.length==1" style="width: 6.9rem;

    margin: 0.28rem auto 0 auto;height:auto;">
      <div class="adver" style="height:auto;">

        <router-link :to="info.routine_home_index_benefit_banner[0].wap_link ? info.routine_home_index_benefit_banner[0].wap_link : ''"
        ><img v-lazy="info.routine_home_index_benefit_banner[0].img" style="height:auto;"
        /></router-link>
      </div>
    </div>

    <div class="slider-banner boutique" v-if="info.routine_home_index_benefit_banner.length>1">
      <swiper class="swiper-wrapper" :options="swiperBoutique2">
        <swiper-slide
            class="swiper-slide"
            v-for="(item, index) in info.routine_home_index_benefit_banner"
            :key="index"
        >
          <router-link :to="item.wap_link ? item.wap_link : ''"
          ><img v-lazy="item.img"
          /></router-link>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination paginationBoutique2"></div>
    </div>
    <Promotion-good :benefit="benefit"></Promotion-good>
    <Coupon-window
      :coupon-list="couponList"
      v-if="showCoupon"
      @checked="couponClose"
      @close="couponClose"
    ></Coupon-window>
    <div style="height:1.2rem;"></div>
    <div>
      <iframe
        v-if="mapKey && !isWeixin"
        ref="geoPage"
        width="0"
        height="0"
        frameborder="0"
        scrolling="no"
        :src="
          'https://apis.map.qq.com/tools/geolocation?key=' +
            mapKey +
            '&referer=myapp'
        "
      >
      </iframe>
    </div>
  </div>
</template>
<style>
.xiaosan .img-box {
    height:2.2rem !important;
}
.xiaosan .swiper-slide {
  width:2.2rem !important;
}
</style>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "@assets/css/swiper.min.css";
import GoodList from "@components/GoodList";
import PromotionGood from "@components/PromotionGood";
import CouponWindow from "@components/CouponWindow";
import cookie from "@utils/store/cookie";
import { getHomeData, getShare, follow } from "@api/public";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { getUser,getUserOpenId, getMenuUser } from "@api/user";
import { isWeixin } from "@utils/index";
import { goShopDetail } from "@libs/order";

import { mapGetters } from "vuex";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
const NAME = "Index";



export default {
  name: NAME,
  components: {
    swiper,
    swiperSlide,
    GoodList,
    PromotionGood,
    CouponWindow
  },
  props: {},
  computed: mapGetters(["isLogin"]),
  data: function() {
    return {
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      subscribe: false,
      followHid: false,
      followCode: false,
      showCoupon: false,
      logoUrl: "",
      banner: [],
        recList:[],
      menus: [],
      roll: [],
      activity: [],
      indexarea:[],
      activityOne: {},
      info: {
        fastList: [],
        bastBanner: [],
        firstList: [],
        bastList: [],
        good_list:[],
      },
      likeInfo: [],
      lovely: [],
      benefit: [],
      couponList: [],
      swiperOption: {
        pagination: {
          el: ".paginationBanner",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true,
        on: {
          tap: function() {
            const realIndex = this.realIndex;
            vm.goUrl(realIndex);
          }
        }
      },
      swiperRoll: {
        direction: "vertical",
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },

        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperScroll: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      swiperBoutique: {
        pagination: {
          el: ".paginationBoutique",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperBoutique1: {
        pagination: {
          el: ".paginationBoutique1",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperBoutique2: {
        pagination: {
          el: ".paginationBoutique2",
          clickable: true
        },
        autoplay: {
          disableOnInteraction: false,
          delay: 2000
        },
        loop: true,
        speed: 1000,
        observer: true,
        observeParents: true
      },
      swiperProducts: {
        freeMode: true,
        freeModeMomentum: false,
        slidesPerView: "auto",
        observer: true,
        observeParents: true
      },
      mapKey: "",
      isFirstEnter: true
    };
  },
  created() {
    vm = this;
    if (this.isLogin === false) {
      this.followHid = false;
    }
  },
  mounted: function() {
    cookie.remove('order_act_account');
    this.getFollow();
    this.get_home_data();
  },
  watch: {
    $route(to, from) {
      // 如果页面重新进入且不是第一次进入，则执行类似 onShow 的逻辑
      if (!this.isFirstEnter && to.name === NAME) {
        cookie.remove('order_act_account');
        this.get_home_data();
      }
      this.isFirstEnter = false;
    }
  },
  methods: {
    get_home_data(){
      let that = this;
      let show_account = cookie.get("login_u_account");
      // let order_act_account = cookie.get("order_act_account");
      // if(order_act_account!='' && order_act_account!=undefined && order_act_account!=null) show_account = order_act_account;
      getHomeData(show_account).then(res => {
        that.mapKey = res.data.tengxun_map_key;
        cookie.set(MAPKEY, that.mapKey);
        that.logoUrl = res.data.logoUrl;
        that.newGoodsBananr = res.data.newGoodsBananr;
        that.$set(that, "banner", res.data.banner);
        that.$set(that, "recList", res.data.recList);

        that.$set(that, "menus", res.data.menus);
        that.$set(that, "roll", res.data.roll);
        that.$set(that, "activity", res.data.activity);
        /*if (res.data.activity.length) {
          var activityOne = res.data.activity.shift();
          that.$set(that, "activityOne", activityOne);
        }*/
        that.$set(that, "info", res.data.info);
        that.$set(that, "likeInfo", res.data.likeInfo);
        that.$set(that,'indexarea',res.data.indexarea);
        that.$set(
            that,
            "lovely",
            res.data.lovely.length ? res.data.lovely[0] : {}
        );
        that.$set(that, "benefit", res.data.benefit);
        that.$set(that, "couponList", res.data.couponList);
        if (that.isLogin) {
          that.subscribe = res.data.subscribe;
          if (!that.subscribe && that.followUrl) {
            setTimeout(function() {
              that.followHid = true;
            }, 200);
          } else {
            that.followHid = false;
          }
        } else {
          that.followHid = false;
        }
        if (res.data.site_name) document.title = res.data.site_name;
        that.setOpenShare();
        this.showCoupon =
            !cookie.has(HAS_COUPON_WINDOW) &&
            res.data.couponList.some(coupon => coupon.is_use);
        //if (!cookie.get(LATITUDE) && !cookie.get(LONGITUDE)) this.getWXLocation();
      });
    },
    // 轮播图跳转
    goUrl(index) {
      let url = this.banner[index].wap_url;
      let newStr = url.indexOf("http") === 0;
      if (newStr) {
        window.location.href = url;
      } else {
        this.$router.push({
          path: url
        });
      }
    },
    // 商品详情跳转
    goDetail(item) {
      goShopDetail(item).then(() => {
        this.$router.push({ path: "/detail/" + item.id });
      });
    },
    getWXLocation() {
      /*if (isWeixin()) {
        wxShowLocation();
      } else {
        if (!this.mapKey)
          console.log("暂无法使用查看地图，请配置您的腾讯地图key");
        let loc;
        // if (_this.$route.params.mapKey) _this.locationShow = true;
        //监听定位组件的message事件
        window.addEventListener(
          "message",
          function(event) {
            loc = event.data; // 接收位置信息 LONGITUDE
            console.log("location", loc);
            if (loc && loc.module == "geolocation") {
              cookie.set(LATITUDE, loc.lat);
              cookie.set(LONGITUDE, loc.lng);
            } else {
              cookie.remove(LATITUDE);
              cookie.remove(LONGITUDE);
              //定位组件在定位失败后，也会触发message, event.data为null
              console.log("定位失败");
            }
          },
          false
        );
      }*/
    },
    closeFollow() {
      this.followHid = false;
    },
    followTap() {
      this.followCode = true;
      this.followHid = false;
    },
    closeFollowCode() {
      this.followCode = false;
      this.followHid = true;
    },
    couponClose() {
      cookie.set(HAS_COUPON_WINDOW, 1);
    },
    getFollow() {
      follow()
        .then(res => {
          this.followUrl = res.data.path;
        })
        .catch(() => {});
    },
    setOpenShare() {
      if (isWeixin()) {
        if(this.isLogin){

          getUser().then(res => {
            var href = location.href;

            href =
                    href.indexOf("?") === -1
                            ? href + "?spread=" + res.data.uid
                            : href + "&spread=" + res.data.uid;
            var nickname = res.data.nickname;


              getShare().then(res => {
                var data = res.data.data;
                var configAppMessage = {
                  desc: '['+nickname+'邀请] '+data.synopsis,
                  title: data.title,
                  link: href,
                  imgUrl: data.img
                };
                openShareAll(configAppMessage);
              });
          })
        }else{
          getShare().then(res => {
            var data = res.data.data;
            var configAppMessage = {
              desc: data.synopsis,
              title: data.title,
              link: location.href,
              imgUrl: data.img
            };
            openShareAll(configAppMessage);
          });
        }


      }
    }
  }
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
.index {
  background-color: #fff;
}

.index .follow {
  z-index: 100000;
}
</style>
